import React, { useEffect, useState } from "react";
import {
  getBrokerPortfolio,
  getInvestorPortfolio,
  getUserDetails,
  userUnlock,
} from "../../../apis/usersApis";
import { useNavigate, useParams } from "react-router-dom";
import { PieChart } from "react-minimal-pie-chart";
// import { PieChart } from "@mui/x-charts";

const UserDetails = () => {
  const { id } = useParams();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [getShareClass, setGetShareClass] = useState([]);
  const [historyLoad, setHistoryLoad] = useState(false);
  const [showPortfolio, setShowPortfolio] = useState(false);
  const [brokerId, setBrokerId] = useState("");
  const [investorCount, setInvestorCount] = useState("");
  const [subscriptionsList, setSubscriptionsList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) userDetails(id);
    setBrokerId(id);
  }, [id]);

  const userDetails = async () => {
    try {
      const res = await getUserDetails(id);
      if (res.success) {
        setDetails(res.result);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const backClick = () => {
    navigate("/usersList");
  };
  const handleUserUnlock = async (id) => {
    if (window.confirm("Are you sure you want to Unlock this user?")) {
      try {
        const res = await userUnlock(id, { status: "A" });
        if (res.success) {
          setDetails(res.result);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const currencyConverter = (val) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "EUR",
    }).format(val);
  };

  const pieChartData = getShareClass.map((item, index) => ({
    title: item.shareClassType,
    value: Number(item.suminfo),
    label: `${item.shareClassType} (${currencyConverter(item.suminfo)})`,
    color: ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"][index % 4],
  }));

  const portfolio = async () => {
    try {
      setShowPortfolio(true);
      const res = await getBrokerPortfolio(brokerId);
      if (res.result) {
        setGetShareClass(res.result.shareClasses);
        setInvestorCount(res.result.subscribers);
        setSubscriptionsList(res.result.subscriptions);
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  // const subscriberList = async () =>{
  //   try{
  //     const res = await getInvestorPortfolio(id);
  //     if(res.result){

  //     }
  //   }catch(error){
  //     console.log(error)
  //   }
  // }
  return (
    <div
      className="container-fluid"
      style={{ paddingLeft: 250, paddingTop: 75 }}
    >
      <i
        className="fas fa-arrow-left"
        style={{ marginRight: "30px", fontSize: "20px" }}
        onClick={backClick}
      />
      {loading ? (
        <div>Loading...</div>
      ) : (
        <>
          {details && details.length > 0 && (
            <div className="table-responsive">
              <table
                className="table table-striped table-hover "
                style={{ marginTop: 25 }}
              >
                <tbody>
                  <tr>
                    <td width={200}>
                      <strong>Name:</strong>
                    </td>
                    <td>
                      {details[0].firstName
                        ? details[0].firstName +
                          (details[0].middleName
                            ? " " + details[0].middleName
                            : "") +
                          (details[0].lastName ? " " + details[0].lastName : "")
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Address 1:</strong>
                    </td>
                    <td>{details[0].address1}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Address 2:</strong>
                    </td>
                    <td>{details[0].address2}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Balance:</strong>
                    </td>
                    <td>{details[0].balance}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Card No:</strong>
                    </td>
                    <td>{details[0].cardNo}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Date of Birth:</strong>
                    </td>
                    <td>{details[0].dateOfBirth}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Email:</strong>
                    </td>
                    <td>{details[0].email}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Mobile:</strong>
                    </td>
                    <td>{details[0].mobile}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Country:</strong>
                    </td>
                    <td>{details[0].countryname}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>County:</strong>
                    </td>
                    <td>{details[0].countyname}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Stripe Customer ID:</strong>
                    </td>
                    <td>{details[0].stripeCustomerId}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>CRM Contact ID:</strong>
                    </td>
                    <td>{details[0].crmContactId}</td>
                  </tr>
                </tbody>
              </table>

              <div style={{ marginTop: "30px" }}>
                {details[0].status === "L" ? (
                  <button
                    className="btn btn-danger"
                    onClick={(text, record) => handleUserUnlock(record.id)}
                  >
                    Unlock
                  </button>
                ) : null}
              </div>
              <div style={{ marginTop: "30px" }}>
                <button
                  className="btn btn-primary "
                  onClick={() => setHistoryLoad(!historyLoad)}
                >
                  View Login History
                </button>
              </div>
            </div>
          )}

          {historyLoad && (
            <div className="table-responsive" style={{ marginTop: 30 }}>
              {details &&
              details.length > 0 &&
              details[0].logintime !== null ? (
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Login Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {details.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          {item.firstName
                            ? item.firstName +
                              (item.middleName ? " " + item.middleName : "") +
                              (item.lastName ? " " + item.lastName : "")
                            : ""}
                        </td>
                        <td>{item.logintime}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div>No Records found</div>
              )}
            </div>
          )}
          <br />
          <button className="btn btn-primary " onClick={() => portfolio()}>
            portfolio
          </button>
          {showPortfolio && (
            <div className="broker-info container">
              {getShareClass && getShareClass.length > 0 ? (
                <div className="broker-Info">
                  <strong>Total Amount</strong>
                  <div>
                    {currencyConverter(
                      getShareClass.reduce(
                        (acc, item) => acc + Number(item.suminfo),
                        0
                      )
                    )}
                  </div>
                </div>
              ) : null}
              <div className="broker-Info">
                <strong>Total Investors</strong>
                <div> {investorCount}</div>
              </div>
              {getShareClass && getShareClass.length > 0 ? (
                <div className="broker-Info">
                  <strong>Total Investments</strong>
                  <div>
                    {getShareClass.reduce(
                      (acc, item) => acc + Number(item.subCount),
                      0
                    )}
                  </div>
                </div>
              ) : null}
              <div>
                {getShareClass && getShareClass.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th> # </th>
                          <th> Share Class</th>
                          <th> Amount Info </th>
                          <th> Subscription Count </th>
                        </tr>
                      </thead>
                      <tbody>
                        {getShareClass &&
                          getShareClass.map((sub, index) => (
                            <tr key={index}>
                              <td> {index + 1} </td>
                              <td> {sub.shareClassType} </td>
                              <td> {sub.suminfo} </td>
                              <td> {sub.subCount} </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                ) : null}
  <div>
                <PieChart
                  data={pieChartData}
                  style={{ height: "200px", width: "400px" }}
                  label={({ dataEntry }) => dataEntry.label}
                  labelStyle={{
                    fontSize: "5px",
                    fontFamily: "sans-serif",
                    fill: "black",
                  }}
                  labelPosition={100}
                />
</div>
              </div>
              <div className="table-responsive">
                <h4> Latest Five Subscriptions Info</h4>

                {subscriptionsList && subscriptionsList.length > 0 ? (
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th> # </th>
                        <th>Seq No</th>
                        <th>Investment Amount</th>
                        <th>Share Class Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      {subscriptionsList.map((sub, index) => (
                        <tr
                          key={index}
                          className="broker-row"
                          onClick={() => {
                            navigate(`/subscriptionDetails/${sub.id}`);
                          }}
                        >
                          <td> {index + 1} </td>
                          <td>{sub.seqNo}</td>
                          <td>{sub.investmentAmount}</td>
                          <td>{sub.shareClassType}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No subscriptions available</p>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UserDetails;
